export interface ChatMessage {
  sender: 'ai' | 'user' | 'system' | 'success';
  message: string;
  timestamp: string;
}

// AI面接システム用の候補者データ型
export interface AICandidateData {
  company_id?: string; // AI面接官プロンプト取得用
  company_name: string;
  industry: string;
  position: string;
  current_industry: string;
  current_position: string;
  is_experience: boolean;
  candidate_type?: 'chuuto' | 'shinsotsu'; // 新卒/中途区分（フェーズ別プロンプト出し分け）
  closing_comment?: string;
  candidate_name: string;
  interview_duration?: number;
  domain_skill_file?: string;
  careerSummary?: string; // 経歴サマリーを追加
  backend_session_id?: string; // 発行(schedule)済みの面接セッションIDを使う場合に指定（開始ごとの新規作成を防ぐ）
}

// AI面接APIレスポンス型
export interface AIInterviewResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

// AI面接セッション情報型
export interface AISessionInfo {
  sessionId: string;
  candidateData: AICandidateData;
  createdAt: Date;
  status: 'active' | 'completed' | 'paused';
  conversationHistory?: ChatMessage[];
}

export type InterviewPhase = 'waiting' | 'active' | 'processing' | 'completed' | 'cancelled';

// 面接のセクション（パート）
export type InterviewSection = 'INTRO' | 'CAREER' | 'CASE' | 'CLOSING';

export interface InterviewSectionConfig {
  id: InterviewSection;
  label: string;
  description: string;
  nextDescription?: string; // 次のパートへ進む際のモーダル説明文
}

export const INTERVIEW_SECTIONS: InterviewSectionConfig[] = [
  {
    id: 'INTRO',
    label: '導入',
    description: '挨拶・AI面接の説明・流れ確認',
    nextDescription: 'これまでの職務経歴や実務経験について詳しくお伺いします。具体的なプロジェクトや担当業務、成果についてお話しください。',
  },
  {
    id: 'CAREER',
    label: '経歴',
    description: '職務経歴・実務経験の深掘り',
    nextDescription: '実際の業務に近い課題をお出しします。論理的な思考プロセスやスキルを確認させていただきます。',
  },
  {
    id: 'CASE',
    label: 'ケース面接',
    description: 'スキル評価・課題解決',
    nextDescription: '面接全体のまとめと、皆さんからのご質問をお受けします。',
  },
  {
    id: 'CLOSING',
    label: '終了',
    description: 'まとめ・質疑応答',
  },
];
